<ng-container *transloco="let t; read: 'home'">
  <div class="p-grid p-nogutter p-jc-center notAGap">
    <div class="p-grid p-nogutter wrapper p-jc-center">
      <div class="p-col-12 notAGap__header">
        <h2 class="home-heading">
          {{ t('not-a-gap.header.1') }}
        </h2>
      </div>
      <div class="p-col-12 notAGap__texts">
        <p [innerHTML]="t('not-a-gap.content.1')"></p>
        <p [innerHTML]="t('not-a-gap.content.2')"></p>
      </div>
      <div class="p-col-12 p-text-center notAGap__charts">
        <div class="p-grid">
          <div class="p-col-12 p-md-6">
            <h2 class="textBlue">
              {{ t('not-a-gap.header.3') }}
            </h2>
            <p class="textBlue p-text-small p-mb-2">{{ t('not-a-gap.chartSubtitle.1') }}</p>
            <img
              src="assets/images/chart1.png"
              class="p-p-1"
              alt="chart"
              loading="lazy"
              decoding="async" width="476" height="476">
          </div>
          <div class="p-col-12 p-md-6">
            <h2 class="textBlue">
              <span [innerHTML]="t('not-a-gap.header.4')"></span>
            </h2>
            <p class="textBlue p-text-small p-mb-2">{{ t('not-a-gap.chartSubtitle.2') }}</p>
            <img
              src="assets/images/chart2.png"
              alt="chart"
              loading="lazy"
              decoding="async" width="378" height="378">
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
